// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3Kypl","info":"PatientInfo_info__1iT4K"};